// @flow
import React from 'react';
import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import styles from './styles.module.scss';
import P from '../../components/Typography/P';
import CustomLink from '../../components/CustomLink/Link';
import routes from '../../constants/routes';

const PasswordChangeSuccess = () => (
  <Card
    use="light"
    className={styles.containerForm}
    title={<H2 color="dark" className={styles.title}>Password Changed</H2>}
  >
    <P
      use="dark"
      size="small"
    >
      Your password has been changed successfuly
    </P>
    <P use="dark">Please log in here</P>
    <CustomLink use="black" name="Log in" to={routes.auth.signIn.root} />
  </Card>
);

export default PasswordChangeSuccess;
